var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isReady
    ? _c("AutomationDesignerDashboard", {
        attrs: { automation: _vm.automation },
        on: { updateAutomation: _vm.updateAutomation },
      })
    : _c("CbDashboardProgressBar", {
        attrs: { isReady: _vm.isReady, text: "Automation Loading" },
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }